import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axios } from "../../utils/axios";

export const fetchCurrencies = createAsyncThunk(
  "currency/fetchCurrencies",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND + "exchange/rates"
      );
      const { conversion_rates, symbols } = response.data.data;
      const currenciesArray = Object.keys(conversion_rates).map((code) => ({
        value: conversion_rates[code], // exchange rate as value
        label: `${code} - ${symbols[code] || code}`,
        symbol: symbols[code] || code,
        code: code,
      }));

      return currenciesArray;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch currencies"
      );
    }
  }
);

// Initial state
const initialState = {
  currencies: [], // list of currencies from API
  selectedCurrency: { value: 1, label: "USD - $", symbol: "$", code: "USD" },
  loading: false,
  error: null,
};

// Slice
export const currencySlice = createSlice({
  name: "currency",
  initialState,
  reducers: {
    setSelectedCurrency: (state, action) => {
      state.selectedCurrency = action.payload;
      localStorage.setItem("selectedCurrency", action.payload.code);
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch currencies
      .addCase(fetchCurrencies.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCurrencies.fulfilled, (state, action) => {
        state.loading = false;
        state.currencies = action.payload;
      })
      .addCase(fetchCurrencies.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// Export actions and reducer
export const { setSelectedCurrency } = currencySlice.actions;
export default currencySlice.reducer;
